import { useLang } from '../context/LanguageContext';
import LegalPageShell from '../components/LegalPageShell';
import ContactContent from '../components/ContactContent';
import { usePageMeta } from '../hooks/usePageMeta';
import { LEGAL_TE_SUMMARIES } from '../content/legalContent';
import './ContactPage.css';

export default function ContactRoutePage() {
  const { t } = useLang();

  usePageMeta({
    title: `${t.contact} | ${t.brandName}`,
    description: `Contact M S Publications — Repatikosam Telugu e-paper. GSTIN 37ACCFM0063B1ZS. Phone +91 9090448890.`,
    path: '/contact',
  });

  return (
    <LegalPageShell title={t.contact} standalone isContact teSummary={LEGAL_TE_SUMMARIES.contact}>
      <ContactContent />
    </LegalPageShell>
  );
}
